import * as React from "react";
import { styled } from "@mui/material";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const base = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 244,
	height: 353,
	fill: "none",
	viewBox: "0 0 244 353",
	...props,
	children: [
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 79.41,
			cy: 317.27,
			fill: "#EDF1F8",
			rx: 48.04,
			ry: 24.45
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 164.4,
			cy: 303.12,
			fill: "#EDF1F8",
			rx: 66.52,
			ry: 33.46
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#0A73BA",
			d: "m134.07 302.54 20.37-266.5c1.97-21.9 15.52-31.57 19.95-32.86 4.95 2.96 3.27 14 1.35 31.58L153.67 306.7l-19.6-4.17Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#1D8AD3",
			d: "m132.29 302.54 20.37-266.5c1.97-21.9 16.87-31.32 21.3-32.62 4.95 2.97 1.91 13.75 0 31.34L151.9 306.7l-19.6-4.17Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#191919",
			fillOpacity: .11,
			d: "M142.3 173.07c9.4 34.4 11.96 115.27 9.98 121.82-2.47 8.2-15.9-119.64-9.97-121.82Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#D9D9D9",
			d: "M132.9 308.54 108.97 42.7c-1.67-21.9 3.15-29.5 7.3-31.52 5.35 2.1 12.4 9.1 13.42 26.73l23.18 271.5-19.95-.86Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#18A0FB",
			d: "M132.9 308.54 108.97 42.7c-1.67-21.9 3.15-29.5 7.3-31.52 5.35 2.1 12.4 9.1 13.42 26.73l23.18 271.5-19.95-.86Z"
		}),
		/* @__PURE__ */ _jsxs("mask", {
			id: "mask0_15552_222872",
			width: 45,
			height: 299,
			x: 108,
			y: 11,
			maskUnits: "userSpaceOnUse",
			style: { maskType: "alpha" },
			children: [/* @__PURE__ */ _jsx("path", {
				fill: "#D9D9D9",
				d: "M132.91 308.54 108.97 42.68c-1.68-21.9 3.15-29.5 7.3-31.52 5.35 2.1 12.4 9.1 13.42 26.73l23.17 271.51-19.95-.86Z"
			}), /* @__PURE__ */ _jsx("path", {
				fill: "#18A0FB",
				d: "M132.91 308.54 108.97 42.68c-1.68-21.9 3.15-29.5 7.3-31.52 5.35 2.1 12.4 9.1 13.42 26.73l23.17 271.51-19.95-.86Z"
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			mask: "url(#mask0_15552_222872)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					fill: "#FA4969",
					d: "m110.5 129.6 3.97-.32-.34-3.84-3.97.32zm-4.83-91.03 81.3-6.62L175.44-98.9l-81.31 6.62z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#FA4969",
					d: "m131.08 38.64 3.98-.32-.34-3.84-3.98.32zm6.9 84.84 3.98-.32-.34-3.85-3.98.33zm4.32 3.52 3.97-.32-.34-3.85-3.97.33zm3.64-4.17 3.97-.32-.34-3.85-3.97.33z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#FA4969",
					d: "m150.24 126.35 3.98-.32-.34-3.85-3.98.33z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m110.77 62.5-.3-3.85 1.99-.14.3 3.84zm.73 9.61.3 3.85 1.98-.14-.3-3.85z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m112.91 64.28-.3-3.85 2-.14.29 3.85zm.44 5.76.3 3.85 1.98-.14-.3-3.85z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m115.05 66.06-.3-3.85 1.98-.14.3 3.85zm.13 1.92.3 3.85 1.98-.14-.3-3.85z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m117.17 67.83-.3-3.84 1.99-.15.3 3.85z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m117.02 65.91.3 3.85 1.98-.14-.3-3.85zm2.35-21.44-.3-3.85 1.99-.14.3 3.85zm.73 9.62.3 3.84 1.99-.14-.3-3.85z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m121.5 46.25-.29-3.84 1.99-.15.3 3.85zm.45 5.77.3 3.85 1.98-.15-.3-3.84z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m123.65 48.04-.3-3.85 1.99-.15.3 3.85zm.14 1.92.3 3.85 1.98-.15-.3-3.85z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m125.77 49.82-.3-3.85 2-.14.29 3.84z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m125.63 47.9.3 3.84 1.98-.14-.3-3.85zm-3.53 6.05.3 3.85-1.98.14-.3-3.85zm-.73-9.62-.3-3.84-1.98.14.3 3.85zm-1.41 7.84.3 3.85-1.99.14-.3-3.85zm-.44-5.77-.3-3.85-1.98.14.3 3.85z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m117.83 50.38.3 3.85-2 .15-.29-3.85zm-.13-1.91-.3-3.85-1.99.14.3 3.85z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m115.7 48.61.3 3.85-1.98.14-.3-3.85z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m115.84 50.53-.3-3.85-1.98.14.3 3.85zm17.53 20.01.3 3.85-2 .14-.29-3.85zm-.74-9.61-.3-3.85-1.98.14.3 3.85zm-1.41 7.83.3 3.85-1.99.14-.3-3.85zm-.44-5.76-.3-3.85-1.98.14.3 3.85z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m129.09 66.98.3 3.85-2 .14-.29-3.85zm-.14-1.92-.3-3.85-1.98.14.3 3.85z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m126.97 65.2.3 3.85-2 .14-.29-3.84z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m127.11 67.12-.3-3.85-1.98.15.3 3.85zm-16.78-10.4-.14-1.92 1.98-.14.15 1.92z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m112.46 58.5-.15-1.92 1.98-.14.15 1.93zm2.14 1.78-.15-1.92 1.98-.14.15 1.92zm2.14 1.79-.15-1.93 1.98-.14.15 1.93zm2.13 1.78-.15-1.93 1.99-.14.15 1.93z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m121 65.63-.15-1.93 1.99-.14.15 1.93zm12.8 10.68.15 1.92-1.98.15-.15-1.93z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m131.68 74.53.15 1.92-1.98.14-.15-1.92zm-2.13-1.78.14 1.92-1.98.14-.15-1.92zm-2.15-1.78.15 1.92-1.98.14-.15-1.92z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m125.28 69.19.15 1.92-1.98.14-.15-1.92zm-2.14-1.79.14 1.93-1.98.14-.15-1.92zm-11.18 10.48.15 1.92 1.98-.14-.14-1.92zm1.84-2.06.16 1.92 1.98-.14-.15-1.93zm1.85-2.07.15 1.92 1.98-.14-.15-1.92z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m117.48 71.68.15 1.93 1.98-.14-.14-1.93zm1.85-2.06.15 1.92 1.98-.14-.15-1.92zm1.84-2.08.14 1.93 1.99-.14-.15-1.93zm11.02-12.37-.15-1.93-1.99.14.15 1.93zm-1.85 2.06-.15-1.92-1.98.14.14 1.92zm-1.84 2.07-.15-1.93-1.98.14.14 1.93zm-1.83 2.06-.15-1.92-1.98.14.14 1.93zm-1.85 2.07-.15-1.92-1.98.14.15 1.92zm-1.83 2.07-.15-1.93-1.98.14.15 1.92zm-3.83 2.2-.14-1.93 1.98-.14.15 1.92zm3.98-.3-.14-1.92 1.98-.14.15 1.93zm-11.94.86-.14-1.92 1.99-.14.14 1.92zm6.63-17.87-.14-1.93 1.98-.14.15 1.92zm2.13 1.78-.14-1.92 1.98-.14.15 1.92zm-.29-3.85-.14-1.92 1.98-.15.15 1.93z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m121.81 50.1-.15-1.92 1.99-.14.15 1.92zm9.27 16.75-.15-1.93 1.99-.14.15 1.92zM106.9 25.93l-.3-3.85 1.98-.14.3 3.85zm.73 9.62.3 3.85 1.98-.14-.3-3.85z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m109.03 27.72-.3-3.85 1.99-.14.3 3.84zm.44 5.76.3 3.85 1.99-.14-.3-3.85z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m111.16 29.5-.3-3.85 2-.15.29 3.85zm.14 1.92.3 3.85 1.99-.15-.3-3.84z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m113.3 31.28-.3-3.85 1.99-.14.3 3.85z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m113.14 29.36.3 3.84 1.98-.14-.3-3.85zm3.09-11.82.3 3.85 1.98-.14-.3-3.85zm1.85-2.07.3 3.85 1.98-.14-.3-3.85zm1.69-3.97-.3-3.86 1.99-.14.3 3.85z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m119.9 13.41.3 3.85 1.99-.14-.3-3.85zm2-.13-.3-3.85 1.99-.15.3 3.85z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m121.75 11.35.3 3.85 1.98-.14-.3-3.85zm-3.52 6.05.3 3.84-1.99.15-.3-3.85zm-2.15-1.78.3 3.84-1.99.15-.3-3.85z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m113.95 13.84.3 3.84-1.98.15-.3-3.85zm-.13-1.92-.3-3.85-1.98.14.3 3.85z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m111.83 12.05.3 3.85-2 .14-.29-3.85z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m111.97 13.97-.3-3.84-1.98.14.3 3.85zm17.52 20.01.3 3.85-2 .14-.29-3.85zm-.74-9.61-.3-3.85-1.98.14.3 3.85zm-1.41 7.83.3 3.85-1.99.15-.3-3.85zm-.44-5.76-.3-3.85-1.98.14.3 3.85z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m125.2 30.42.3 3.85-1.98.14-.3-3.85zm-.13-1.92-.3-3.85-1.98.15.3 3.84z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m123.08 28.64.3 3.85-1.99.15-.3-3.85z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m123.23 30.57-.3-3.85-1.98.14.3 3.85zm-14.65-8.62-.15-1.92 1.98-.15.15 1.93zm2.13 1.78-.15-1.93 1.99-.14.15 1.93z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m112.84 25.51-.15-1.92 1.99-.14.15 1.92zm2.14 1.79-.15-1.93 1.99-.15.15 1.93z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m117.1 29.07-.14-1.92 1.99-.14.14 1.92zm12.83 10.69.14 1.92-1.98.14-.15-1.92z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m127.8 37.97.15 1.93-1.98.14-.15-1.92zm-2.13-1.77.14 1.92-1.98.15-.15-1.93zm-2.15-1.78.15 1.92-1.98.14-.15-1.92z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m121.4 32.63.14 1.93-1.99.14-.14-1.92zm-2.14-1.78.15 1.93-1.99.14-.14-1.93zm-11.2 10.47.15 1.92 1.99-.14-.15-1.92zm1.85-2.07.15 1.92 1.98-.14-.14-1.92zm1.84-2.06.15 1.92 1.98-.14-.14-1.93z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m113.59 35.12.14 1.93 1.99-.15-.15-1.92zm1.84-2.06.15 1.92 1.98-.14-.15-1.93zm1.83-2.07.15 1.92 1.99-.14-.15-1.92zM128.3 18.6l-.14-1.92-1.99.14.15 1.93zm-1.84 2.07-.14-1.92-1.99.14.15 1.92zm-1.84 2.07-.15-1.92-1.99.14.15 1.92zm-1.82 2.06-.15-1.92-1.99.14.15 1.92zm-1.85 2.07-.15-1.92-1.99.14.15 1.92zm-1.85 2.06-.14-1.92-1.98.14.14 1.92zm-3.83 2.21-.15-1.93 1.99-.14.15 1.93z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m119.25 30.85-.14-1.93 1.98-.14.15 1.93zm-11.92.85-.15-1.92 1.99-.14.14 1.92zm6.62-17.87-.15-1.92 1.98-.14.15 1.92z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m116.07 15.61-.14-1.92 1.98-.15.15 1.93zm-.29-3.84-.15-1.93 1.99-.14.14 1.93zm2.14 1.77-.15-1.92 1.99-.14.14 1.92zm9.28 16.74-.15-1.93 1.98-.14.15 1.93zm-13.63 68.76-.3-3.85 1.99-.14.3 3.84zm.73 9.61.3 3.85 1.98-.14-.3-3.85z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m115.7 100.82-.3-3.85 2-.14.29 3.85zm.45 5.77.3 3.85 1.98-.14-.3-3.85zm1.7-3.99-.3-3.85 1.99-.14.3 3.85zm.13 1.92.3 3.85 1.98-.14-.3-3.85z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m119.97 104.38-.3-3.85 1.99-.15.3 3.85z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m119.82 102.46.3 3.85 1.98-.14-.3-3.85zm2.36-21.44-.3-3.85 2-.14.29 3.85zm.74 9.62.3 3.85 1.98-.14-.3-3.85z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m124.32 82.8-.3-3.85 2-.14.29 3.85zm.43 5.77.3 3.85 1.98-.15-.3-3.85z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m126.45 84.58-.3-3.85 1.99-.14.3 3.85zm.15 1.92.3 3.86 1.98-.15-.3-3.84z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m128.59 86.37-.3-3.85 1.99-.14.3 3.85z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m128.44 84.44.3 3.85 1.98-.14-.3-3.85zm-3.54 6.06.3 3.85-2 .14-.29-3.85zm-.74-9.62-.3-3.84-1.98.14.3 3.85zm-1.41 7.84.3 3.85-1.99.14-.3-3.85zm-.44-5.77-.3-3.85-1.98.14.3 3.85z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m120.62 86.94.3 3.85-2 .14-.29-3.85zm-.14-1.92-.3-3.85-1.98.14.3 3.85z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m118.5 85.16.29 3.84-1.99.15-.3-3.85z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m118.64 87.07-.3-3.84-1.98.14.3 3.85zm17.53 20.02.3 3.84-2 .15-.29-3.85zm-.74-9.62-.3-3.85-1.98.14.3 3.85z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m134.03 105.3.3 3.85-1.99.14-.3-3.84zm-.45-5.76-.3-3.85-1.98.14.3 3.85zm-1.69 3.99.3 3.85-1.99.14-.3-3.85z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m131.75 101.6-.3-3.85-1.98.14.3 3.85zm-1.98.14.3 3.85-2 .14-.29-3.84z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m129.91 103.66-.3-3.84-1.98.14.3 3.85zm-16.78-10.38-.15-1.93 1.98-.14.15 1.92z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m115.24 95.06-.15-1.93 1.99-.14.15 1.93zm2.14 1.78-.15-1.92 1.99-.15.14 1.93zm2.15 1.78-.15-1.92 1.98-.15.15 1.93zm2.13 1.78-.15-1.93 1.99-.14.14 1.93zm2.13 1.78-.15-1.92 1.99-.14.14 1.92zm12.82 10.68.15 1.93-1.98.14-.15-1.93zm-2.13-1.78.14 1.92-1.98.14-.15-1.92z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m132.35 109.3.15 1.92-1.98.14-.15-1.92zm-2.14-1.78.15 1.92-1.99.15-.14-1.93zm-2.14-1.78.15 1.92-1.99.14-.14-1.92z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m125.95 103.95.15 1.93-1.99.14-.15-1.92zm-11.21 10.47.15 1.92 1.99-.14-.15-1.92zm1.85-2.07.14 1.92 1.99-.14-.15-1.93z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m118.43 110.28.14 1.93 1.99-.14-.15-1.93zm1.84-2.06.14 1.92 1.99-.14-.15-1.93z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m122.1 106.15.15 1.93 1.99-.14-.15-1.93zm1.85-2.06.15 1.92 1.98-.14-.15-1.93zM135 91.7l-.16-1.92-1.98.14.15 1.92zm-1.84 2.07-.15-1.92-1.99.14.15 1.92zm-1.85 2.06-.14-1.92-1.99.14.15 1.93z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m129.47 97.9-.14-1.93-1.99.14.15 1.92zm-1.84 2.06-.15-1.92-1.99.14.15 1.93z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m125.79 102.03-.15-1.93-1.98.14.14 1.93zm-3.83 2.2-.15-1.92 1.99-.14.14 1.92z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m125.93 103.96-.15-1.93 1.99-.14.14 1.92zm-11.93.84-.15-1.92 1.99-.14.15 1.93zm6.62-17.87-.15-1.93 1.98-.14.15 1.93zm2.14 1.77-.15-1.92 1.99-.14.15 1.92zm-.3-3.83-.14-1.93 1.98-.14.15 1.93z"
				}),
				/* @__PURE__ */ _jsx("path", {
					fill: "#fff",
					d: "m124.6 86.65-.15-1.92 1.99-.15.14 1.93zm9.28 16.73-.15-1.92 1.98-.15.15 1.93z"
				})
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FFF4E0",
			d: "M122.65 191.76c.1-2.2 2.75-12.56 4.07-17.47 2.03-.1 6.2-.39 6.65-.81.46-.42 6.56 14.07 9.55 21.37l-19.9 1.34a15.8 15.8 0 0 1-.37-4.43Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#687488",
			d: "m126.11 188.05 11.06-.62 4.06 45.29-10.48 1-4.64-45.67Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#2A4550",
			d: "m124.14 199.14 3.92-5.82 9.38-.77 4.92 5.15 1.77-1.36c-1.8-1.97-5.56-5.98-6.14-6.24-.73-.32-10.66 1.04-11.56.91-.72-.1-3.34 4.8-4.55 7.27l2.26.86Z"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 16.19,
			height: 12.52,
			x: 124.3,
			y: 192.95,
			fill: "#274253",
			rx: 6.26,
			transform: "rotate(-5.77 124.3 192.95)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#1D3138",
			d: "m125.17 198.52 3.05-5.58 6.9-.8-6.15 2.27-3.75 6.2-.05-2.1Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#2A4550",
			d: "m145.93 235.82-3.92 5.82-9.38.78-4.92-5.15-1.77 1.35c1.8 1.97 5.56 5.98 6.14 6.24.73.33 10.66-1.03 11.56-.91.72.1 3.34-4.8 4.55-7.27l-2.26-.86Z"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 16.19,
			height: 12.52,
			x: 145.77,
			y: 242.01,
			fill: "#274253",
			rx: 6.26,
			transform: "rotate(174.22 145.77 242.01)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#1D3138",
			d: "m144.9 236.45-3.05 5.57-6.9.8 6.15-2.27 3.75-6.2.05 2.1Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#687488",
			d: "M127.1 174.01c-.76.18-1.1 9.44-.99 14.05 3.51-.17 9.38-.15 11.06-.63-.48-1.67-2.38-9.49-3.94-13.85-1.73-.46-5.08.18-6.13.43Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#CDD1D7",
			d: "M128.83 309.87 30.46 164.4l-4.34 1.98 98.37 145.46 4.34-1.98Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#354661",
			d: "M32.74 165c-1.75-.44-13.5-17.21-19.16-25.55-8.64 1.26-10.9 6.18-10.96 8.48 1.79.57 5.84 1.67 7.73 1.52 2.36-.19 1.02 6.8 3.28 5.44 2.27-1.37 9.21 11.14 10.22 11.77.8.5-.45 2.33-1.17 3.18l2.19 3.63 5.44-3.29c4.53-2.74 6.16-3.1 7.25-4.38 1.08-1.28-2.64-.27-4.82-.8Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#CDD1D7",
			d: "M112.48 310 75.42 138.36l-4.76.21 37.06 171.65 4.76-.22Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#354661",
			d: "M77.31 139.75c-1.46-1.06-6.1-21-8.25-30.85-8.5-2.05-12.43 1.67-13.34 3.78 1.45 1.2 4.8 3.73 6.6 4.3 2.27.7-1.58 6.7 1.03 6.26 2.61-.42 4.4 13.77 5.09 14.73.55.77-1.29 2-2.27 2.52l.68 4.18 6.27-1.02c5.23-.86 6.88-.59 8.36-1.37 1.48-.78-2.34-1.22-4.17-2.53Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FEB95E",
			d: "M192.83 260.97c2.82-9.9 14.46-20.94 19.93-25.22l5.98 2.3c2.16 4.34 1.59 22.9-1.98 32.15l-12.35-4.2-11.58-5.03Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "m210.4 237.77 2.57-2.28c2.19 0 6.39.51 5.7 2.57-.68 2.05-5.8.66-8.26-.29Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#EC4949",
			stroke: "#EC4949",
			strokeWidth: 1.44,
			d: "m185.97 278.74 6.78-17.59a167.37 167.37 0 0 0 24.12 9.3l-6.78 17.59c-9.59-2.56-14.89-4.45-24.12-9.3Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#EC4949",
			d: "m213.63 232.96 1.68-4.35 6.7 2.59c-.44 1.5-1.28 3.88-1.67 4.35l-6.71-2.59Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "m213 235.64.99-2.54 5.62 2.17-.98 2.54-5.62-2.17Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#FB8431",
			d: "M176.04 250.36c21.08 2.03 34.52 51.55-11.75 46.12-23.05-2.7-28.47-50 11.75-46.12Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#499D69",
			d: "M186.47 246.24c-8.19-.97-12.42 5.58-13.52 8.98-2.19 0-4.48 1.07 3.86 5.35 10.42 5.35 19.9-13.12 9.66-14.33Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#F5A45C",
			d: "M188.6 273.54c4.83 1.69 4.56-4.52 2.17-6.74-3-2.78-7.7-1.47-2.17 6.74Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#237D45",
			d: "M173.76 255.55c2.85.85 8.78 1.94 9.7-.57 1.13-3.14-8-.86-9.7.57Z"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 76.8,
			cy: 328.09,
			fill: "#fff",
			rx: 48.04,
			ry: 24.45
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 177.48,
			cy: 313.58,
			fill: "#fff",
			rx: 66.52,
			ry: 33.46
		})
	]
});
const SvgSkis = styled(base)({});
export default SvgSkis;
